<script>
  import Hero from "../Hero.svelte";
  import Slide from "../Slide.svelte";
  import Conclusion from "../Conclusion.svelte";

  import { windowWidth, currentYear } from "../../stores/global.js";

  export let data;
  export let years;
  export let safari;

  import { Swiper, SwiperSlide } from "swiper/svelte";
  import SwiperCore, {
    Keyboard,
    Mousewheel,
    FreeMode,
    Scrollbar,
    Navigation,
    HashNavigation,
  } from "swiper";

  SwiperCore.use([
    Keyboard,
    Mousewheel,
    FreeMode,
    Scrollbar,
    Navigation,
    HashNavigation,
  ]);

  let activeYear = null;

  // We want to prerender titles for the slides surrounding the active year
  $: index = years.indexOf(activeYear);
  $: shouldRenderTitlesFor = function (year) {
    return years
      .slice(Math.max(index - 1, 0), index + 2) // Don't slice with a negative index
      .includes(year);
  };

  let cssMode = true;
</script>

<div id="mobile-layout">
  <Swiper
    modules={[
      Keyboard,
      Mousewheel,
      FreeMode,
      HashNavigation,
      Navigation,
      Scrollbar,
    ]}
    keyboard
    hashNavigation={{
      watchState: true,
      replaceState: true,
    }}
    navigation={false}
    mousewheel={true}
    scrollbar={{
      hide: false,
      draggable: true,
    }}
    freeMode={{
      enabled: false,
      momentum: true,
      sticky: true,
      momentumBounce: true,
    }}
    centeredSlides={false}
    slidesPerView={"auto"}
    spaceBetween={0}
    {cssMode}
    speed={600}
    followFinger={true}
    on:slideChange={(e) => {
      activeYear = years[e.detail[0][0].activeIndex - 1]; // ! Decrement this according to how many 'starting' slides there are
      currentYear.set(activeYear);
    }}
  >
    <SwiperSlide class="first" data-hash=""><Hero /></SwiperSlide>
    {#each years as year, index}
      <Slide
        data={data.filter((d) => d.year == year)}
        even={index % 2 == 0 ? true : false}
        width={$windowWidth / 2.5}
        slideIsActive={activeYear == year}
        shouldRenderTitles={true}
        {year}
      />
    {/each}
    <SwiperSlide class="last" data-hash="conclusion"><Conclusion /></SwiperSlide
    >
  </Swiper>
</div>

<style>
  :global(#mobile-layout .swiper-button-prev, #mobile-layout
      .swiper-button-next) {
    top: unset;
    bottom: calc(40px + 2%) !important;
    color: white !important;
    padding: 0.5rem;
  }
  /* .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    left: unset;
  } */

  :global(#mobile-layout .swiper-wrapper, #mobile-layout .swiper-slide) {
    padding-bottom: 39px;
  }

  @media screen and (max-width: 768px) {
    :global(#mobile-layout .swiper .swiper-scrollbar) {
      cursor: auto;
      top: 5px;
      height: 10px;
    }

    /* This fixes lagginess of mobile when cssMode is turned off */
    :global(#mobile-layout .swiper-wrapper) {
      transition: all 601ms ease !important;
    }
  }

  /* We need to undo swiper-slide transform properties on mobile, because it creates flickering issue 
  The below targets landscape mode phones and all portrait mode phones */
  @media screen and (max-width: 812px) and (max-height: 375px),
    screen and (max-width: 768px) {
    :global(.swiper-slide) {
      transform: none !important;
      -webkit-transform: none !important;
    }
  }
</style>
